











import WField from "./WField.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WFieldButton extends WField {
	@Prop({ type: String, default: "click" }) eventName!: String;
}
